import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($props.country == 'IL')
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          innerHTML: _ctx.$t('ml_151038', { company: $props.company }, 'x-Welcome to MyAP Israel')
        }, null, 8, _hoisted_1))
      : ($props.company == 'Portal' && $props.mobile)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            innerHTML: _ctx.$t($options.portalMobileTranslateId, 'x-Welcome to MyPortal Mobile')
          }, null, 8, _hoisted_2))
        : ($props.company == 'Portal' && $props.premium)
          ? (_openBlock(), _createElementBlock("p", {
              key: 2,
              innerHTML: _ctx.$t($options.portalPremiumTranslateId, 'x-Welcome to MyPortal Premium')
            }, null, 8, _hoisted_3))
          : ($props.company == 'Portal')
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                innerHTML: _ctx.$t($options.portalDefaultTranslateId, 'x-Welcome to MyPortal Basic')
              }, null, 8, _hoisted_4))
            : (['US', 'CA'].includes($props.country))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  innerHTML: _ctx.$t('ml_107025', { company: $props.company }, 'x-Save time online... with your account management system')
                }, null, 8, _hoisted_5))
              : ($props.mobile)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 5,
                    innerHTML: _ctx.$t('ml_107002', { company: $props.company }, 'x-Welcome to MyAP Mobile')
                  }, null, 8, _hoisted_6))
                : ($props.premium)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 6,
                      innerHTML: _ctx.$t('ml_107005', { company: $props.company }, 'x-Welcome to MyAP Premium')
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 7,
                      innerHTML: _ctx.$t('ml_107003', { company: $props.company }, 'x-Welcome to MyAP Basic')
                    }, null, 8, _hoisted_8))
  ]))
}